import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface StaffUser {
  id: string;
  full_name?: string;
  username?: string;
}

/**
 * Usuários internos (admin/membro) para o dropdown de "responsável" pela vaga.
 * Antes era um fetch cru em Vagas.tsx (useState/useEffect, sem cache),
 * disparado em todo mount de /vagas. Movido pro TanStack Query: deduplica e
 * mantém o resultado em cache entre montagens/componentes.
 *
 * NÃO confundir com useUserPermissions: aquele lê a MESMA view
 * (v_profiles_with_access_profile) mas filtrando o usuário logado (1 linha por
 * id) com outras colunas. São dados diferentes — não há duplicação a fundir.
 */
export function useStaffUsers() {
  return useQuery({
    queryKey: ["users-for-assignment"],
    staleTime: 5 * 60 * 1000,
    queryFn: async (): Promise<StaffUser[]> => {
      const { data, error } = await supabase
        .from("v_profiles_with_access_profile")
        .select("id, full_name, username")
        .in("access_profile_slug", ["admin", "membro"])
        .order("full_name");
      if (error) throw error;
      return (data || []) as StaffUser[];
    },
  });
}
